export const staticData = {
  subSection: [
    {
      imgSrc: "/image/transparentLogo.webp",
      service: "For Corporates",
      texts: [
        "You are about to enter into a FX deal with Forwards and Options.",
        "Or, you are about to do an interest rate swap on a loan contract and you know that a few basis points can translate into a lot of money being left on the table. ",
        "Would you like to know the fair value of your deal so that you can negotiate effectively a fair price with your counterparty? ",
        "What if you could use a pricer without signing up for an expensive, long-term contract with a terminal provider?",
        "What if you could choose to pay only when you needed to price?",
        "Enter Finvisage.",
      ],
    },
    {
      imgSrc: "/image/transparentLogo.webp",
      service: "For Forex Consultants",
      texts: [
        "You are a consultant to your corporate clients advising them on their FX and interest rate hedging needs. ",
        "You may be guiding them on their choice of structures and timings of execution.  ",
        "How do you tie them in with your firm by offering them a technological solution that they will need regularly?",
        "Offer your clients a derivatives pricer through your Program ensuring they value the expertise and tools you bring to the table.",
        "Enter Finvisage’s Program service built specifically for consultants.  ",
      ],
    },
    {
      imgSrc: "/image/transparentLogo.webp",
      service: "For Banks",
      texts: [
        "Today only a handful of global investment banks can afford to give every Derivatives corporate salesperson a terminal for pricing of their own.",
        "What about the rest?",

        "Finvisage is a web-based pricing app (also a world first phone app) priced at a fraction of a market terminal.",
        "Current bank customers in India have rolled out Finvisage to all their salespeople. The UI has received high praise for being easy to use, clean and clutter-free.",
        "Enter Finvisage.",
      ],
    },
    {
      imgSrc: "/image/transparentLogo.webp",
      service: " For NBFCs",

      texts: [
        "You are managing multiple loans, facilities, NCDs, PTCs, and structured borrowings.",
        "Each comes with its own drawdowns, schedules, covenants, pools, and reporting obligations.",
        "A small error in schedules, covenant tracking, or pool allocation can lead to audits, regulatory issues, or financial impact.",
        "Would you like to know, at any point in time, exactly what you owe, to whom, when, and under what conditions?",
        "What if your entire liability book - loans, securitisations, covenants, lived in one system, not across spreadsheets?",
        "Enter Finvisage BALM.",
      ],
    },
  ],
  corporates: {
    videoLink: "4BcEAWLUqec",
    title:
      "Here’s a video showing how to sign up & start using our derivatives pricer",
  },
  fx: {
    videoLink: "R1L4qzJwmVQ",
    title:
      "Here’s how to sign up as a Forex consultant & start using our derivatives pricer",
  },
  Nbfcs: {
    videoLink: "KPwtIWw4m7U",
    title:
      "Here’s a video showing how to use BALM for securitization through PTC/DA",
  },

  midSection: [
    {
      title: "Precise derivative valuations at your fingertips",
      QA: [
        {
          question: "Do I need a credit card to sign up?",
          answer:
            "No, you can sign up without a credit card. We use a credits based pricing model where you add credits to your account and select the packs you need to start pricing.",
          imgSrc: "/image/allFAQimgs/creditCardFAQ.webp",
        },

        {
          question:
            "How do your prices benchmark against the large terminal players in the market?",
          answer:
            "Our prices have been checked and validated by many external parties. Our prices match exactly with the largest terminal provider globally. Our enterprise product is used by banks in their front offices and has been deployed after extensive validation.",
          imgSrc: "/image/allFAQimgs/targetFAQ.webp",
        },
        {
          question: "What structures and assets can I price?",
          answer:
            "We cover FX and interest rate derivatives structures. You can price short and long-term forwards, FX options, crosses, RFR swaps, and cross currency swaps. This covers 99% of the FX and IR derivatives markets today by notional.",
          subHeading:
            "If you would like to price equity options or price exotic derivatives, please get in touch with us.",
          imgSrc: "/image/allFAQimgs/structureFAQ.webp",
        },
        {
          question: "Do I need a monthly license to use Finvisage?",
          answer:
            "No, you only need to add enough credits to cover your pricing requirements. We charge you based on your daily usage. Once your credits expire, your pricing ability is paused till credits are added again. ",
          imgSrc: "/image/allFAQimgs/calenderFAQ.webp",
        },
      ],
    },

    {
      title: "Step Up Your Financial Game with Finvisage",
      QA: [
        {
          question: "How can I, as an FX consultant, sign up for Finvisage?",
          answer:
            "You can sign up using the links available on this website and then reach out to us by filling in your information and submitting the form at the end of this page. We will reach out to you, complete the onboarding formalities, and tag you as an FX consultant.",
          imgSrc: "/image/allFAQimgs/signupFAQ.webp",
        },

        {
          question:
            "How do your prices benchmark against the large terminal players in the market?",
          answer:
            "Our prices have been checked and validated by many external parties. Our prices match exactly with the largest terminal provider globally. Our enterprise product is used by banks in their front offices and has been deployed after extensive validation.",

          imgSrc: "/image/allFAQimgs/targetFAQ.webp",
        },
        {
          question: "What structures and assets can I price?",
          answer:
            "We cover FX and interest rate derivatives structures. You can price short and long-term forwards, FX options, crosses, RFR swaps, and cross currency swaps. This covers 99% of the FX and IR derivatives markets today by notional. ",
          subHeading:
            "If you would like to price equity options or price exotic derivatives, please get in touch with us.",
          imgSrc: "/image/allFAQimgs/structureFAQ.webp",
        },
        {
          question:
            "How can I get my clients onboarded to Finvisage, but still manage their pricing abilities?",
          answer:
            "FX consultants have exclusive access to the ‘Program’ feature, which allows you to define the pricing structures accessible, manage client lifecycles, view your own as well as your client’s billing details along with plenty of other features. ",

          imgSrc: "/image/allFAQimgs/clientFAQ.webp",
        },
        {
          question:
            "How will I be billed for usage of the pricer by myself and my clients?",
          answer:
            "We follow a monthly usage cycle for FX consultants and there are no fixed term contracts. Details can be shared during the signup process.",
          imgSrc: "/image/allFAQimgs/billFAQ.webp",
        },
      ],
    },
    {
      title: "Market-Tested Valuations with Finvisage",
      QA: [
        {
          question:
            "How do your prices benchmark against the large terminal players in the market?",
          answer:
            "Our prices have been checked and validated by many external parties. Our prices match exactly with the largest terminal provider globally. Our enterprise product is used by banks in their front offices and has been deployed after extensive validation.",
          imgSrc: "/image/allFAQimgs/targetFAQ.webp",
        },

        {
          question: "What structures and assets can I price?",
          answer:
            "We cover FX and interest rate derivatives structures. You can price short and long-term forwards, FX options, crosses, RFR swaps, and cross currency swaps. This covers 99% of the FX and IR derivatives markets today by notional.",
          subHeading:
            "If you would like to price equity options or price exotic derivatives, please get in touch with us.",
          imgSrc: "/image/allFAQimgs/structureFAQ.webp",
        },
        {
          question: "What other features do you have for banks & enterprises?",
          answer:
            "In addition to the above mentioned structures, we can also price equity options, or price exotic derivatives. We have market data editing capabilities, portfolio valuation services, scenario based results and several other features available to give you the best pricing experience.",
          imgSrc: "/image/allFAQimgs/featureFAQ.webp",
        },
      ],
    },
    {
      title:
        "Step into effortless liability management with Finvisage’s BALM",
      QA: [
        {
          question: "What is Finvisage BALM?",
          answer:
            "Finvisage BALM (Borrowings & Liability Management) is an enterprise-grade SaaS platform built specifically for NBFC treasury and finance teams. Manage complex liabilities, from drawdown to maturity, PTC pool creation to investor payouts and covenant setup to compliance reporting. Ensure accuracy, compliance, and audit readiness, all in one system, eliminating spreadsheet risk.",
          imgSrc: "/image/allFAQimgs/Nbfcs_FAQ_1.webp",
        },

        {
          question:
            "What liability instruments can I manage on Finvisage BALM?",
          answer: {
            intro: "Finvisage supports your complete liability book in one place, managing everything from loan creation to reporting across:",
            points: [
              "Loans & Facilities: Term Loans, WC Loans, CC, OD, ECB",
              "Market Instruments: NCDs, CCDs, CPs, MLDs",
              "Structured & Secured: PTC, DA, Hypothecation"
            ]
          },
          imgSrc: "/image/allFAQimgs/Nbfcs_FAQ_2.webp",
        },
        {
          question: "What features does Finvisage BALM offer?",
          answer: {
            intro: "Finvisage offers",
            points: [
              "Real-time dashboards for visibility into payment dues, lender exposure, limits and yields - all customizable.",
              "Automated alerts for payment due, maturities, upcoming covenants, and breaches.",
              "Maker-checker controls for approval and data integrity.",
              "Generation of all cashflows and all types of repayment schedules.",
              "Covenant tracking with auto-generated compliance reports.",
              "PTC & DA management from pool creation to payouts and performance tracking.",
              "Comprehensive, customizable reports covering borrowing treasury, daily principal and interest, covenants, management dashboards, and regulatory reports."
            ]
          },
          imgSrc: "/image/allFAQimgs/Nbfcs_FAQ_3.webp",
        },
        {
          question: "Why do NBFCs choose Finvisage?",
          answer:
            "Finvisage reduces manual effort, eliminates spreadsheet errors, ensures accurate and audit-ready schedules and reports, strengthens compliance, and provides complete visibility and control over the entire liability lifecycle, enabling finance, treasury and operations teams to work seamlessly on a single platform.",
          imgSrc: "/image/allFAQimgs/Nbfcs_FAQ_4.webp",
        },
        {
          question:
            "What support is provided during implementation & post go-live?",
          answer:
            "Our team works closely with your finance and operations teams to install and set up the system by migrating data, validating schedules, configuring workflows and training users, ensuring a smooth and controlled go-live. Deployment will be customized according to your needs. Post go-live, clients receive continuous support, platform updates, and periodic reviews to ensure BALM evolves with their business.",
          imgSrc: "/image/allFAQimgs/Nbfcs_FAQ_5.webp",
        },
      ],
    },
  ],
};
